import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";
import axios from "axios";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Faq = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/faqs`)
      .then((r) => setItems(r.data))
      .catch(() => {});
  }, []);

  if (!items.length) return null;

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: { "@type": "Answer", text: item.answer },
    })),
  };

  return (
    <section data-testid="faq-section" className="py-24 md:py-32 bg-[#F5F5F7]">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Helmet>
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12 md:mb-16"
        >
          <p className="text-xs md:text-sm tracking-[0.2em] uppercase font-semibold text-[#86868B] mb-6">
            Questions, Answered
          </p>
          <h2
            data-testid="faq-heading"
            className="font-display text-4xl md:text-5xl leading-tight tracking-tight font-medium text-[#1D1D1F]"
          >
            Curious about water from air?
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, delay: 0.1 }}
        >
          <Accordion type="single" collapsible className="space-y-3">
            {items.map((item, i) => (
              <AccordionItem
                key={item.id}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="bg-white rounded-2xl px-6 border-none"
              >
                <AccordionTrigger className="text-left text-base md:text-lg font-medium text-[#1D1D1F] hover:no-underline py-5">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-sm md:text-base leading-relaxed text-[#86868B] pb-6">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};
